import { IFieldMeta } from '../../interfaces/imetadata';

export interface IFilterableItem {
  id: string;
  label: string;
  data?: any; // TODO: BW - use generics?
  icon?: string;
}

export class FilterableItem implements IFilterableItem {
  id = '';
  label = '';
  data?: any;
  icon?: string;

  public static newFilterableItem(id: string, label: string, data?: any, icon?: string): IFilterableItem {
    const filterableItem = new FilterableItem();
    filterableItem.id = id;
    filterableItem.label = label;
    filterableItem.data = data;
    filterableItem.icon = icon;
    return filterableItem;
  }

  public static fromFieldMeta(field: IFieldMeta): IFilterableItem {
    const leaf = (path: string) => {
      const parts = path.split('.');
      return parts.length > 0 ? ` (${parts.slice(-1)[0]})` : '';
    };
    const filterableItem = new FilterableItem();
    filterableItem.id = field.path;
    filterableItem.label = `${field.label}${leaf(field.path)}`;
    filterableItem.data = field;
    return filterableItem;
  }
}
